import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';
import { waitForAuth } from '../../../../data/authUtils';
import type { PageRequest, RawRow } from './exportTypes';

export class OldFunctionError extends Error {
    constructor() {
        super('The server function loadEventPrices is not up to date.');
        this.name = 'OldFunctionError';
    }
}

interface PageResponse {
    data?: RawRow[];
    side?: string | null;
    filled?: boolean;
}

export async function loadCandlePage(
    request: PageRequest,
    signal: AbortSignal
): Promise<RawRow[]> {
    await waitForAuth();
    if (signal.aborted) throw new DOMException('Aborted', 'AbortError');

    const callable = firebase
        .app()
        .functions('europe-west6')
        .httpsCallable('loadEventPrices', { timeout: 120_000 });
    const result = await callable({
        conditionId: request.conditionId,
        side: request.side,
        fill: false,
        startDate: new Date(request.startMs).toISOString(),
        endDate: new Date(request.endMs).toISOString(),
        intervalMinutes: request.intervalMinutes,
    });
    if (signal.aborted) throw new DOMException('Aborted', 'AbortError');

    const response = (result.data ?? {}) as PageResponse;
    if (response.side !== request.side || response.filled !== false) {
        throw new OldFunctionError();
    }
    return Array.isArray(response.data) ? response.data : [];
}
